export const externalTabDetails = {
  leftPanelData: {
    leftPanelHeader: 'loyalty_info',
    subTitle: 'gold_elite',
    points: 'points',
    recentTrips: [
      {
        id: 1,
        imageUrl: './assets/MarriottDallas.png',
        tripTiltle: 'marriott_dallas',
        confirmationId: '#346342',
        date: 'sep_date',
        tripType: 'recent_trips',
      },
      {
        id: 2,
        imageUrl: './assets/MarriottHawaii.png',
        tripTiltle: 'marriott_hawaii',
        confirmationId: '#434233',
        date: 'aug_date',
        tripType: '',
      },
      {
        id: 3,
        imageUrl: './assets/MarriottFlorida.png',
        tripTiltle: 'marriott_florida',
        confirmationId: '#546346',
        date: 'jul_date',
        tripType: '',
      },
    ],
    leftPanelSubHeader: [
      {
        id: 1,
        imageUrl: './assets/CourtyardMiami.png',
        tripTiltle: 'courtyard_miami',
        confirmationId: '#633222',
        date: 'sep_date',
        tripType: 'upcoming_trips',
      },
      {
        id: 2,
        imageUrl: './assets/MarriottHawaiiUpcoming.png',
        tripTiltle: 'marriott_hawaii',
        confirmationId: '#434233',
        date: 'aug_date',
        tripType: '',
      },
      {
        id: 3,
        imageUrl: './assets/MarriottFloridaUpcoming.png',
        tripTiltle: 'marriott_florida',
        confirmationId: '#546346',
        date: 'jul_date',
        tripType: '',
      },
    ],
  },
  rightPanelData: {
    title: 'ServiceNow CRM',
    subDetails: [
      {
        recordId: 1,
        caseId: `#${Math.floor(Math.random() * (999 - 100 + 1)) + 100}`,
        status: 'low_status',
        date: '3/9/2024 8:32pm',
        crmImage: '/assets/nowCase.png',
        crmUrl: 'http://www.crm.com',
        details: 'servicenow_current_record_details',
        recordType: 'current_record',
      },
      {
        recordId: 2,
        caseId: `#${Math.floor(Math.random() * (999 - 100 + 1)) + 100}`,
        crmImage: '/assets/nowCase.png',
        crmUrl: 'http://www.crm.com',
        status: 'closed',
        date: '3/2/2024 12:54pm',
        details: 'servicenow_related_record_details',
        recordType: 'related_record',
      },
    ],
  },
};
